import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from '../app-routing.module';
import { AuthenticationModule } from '../authentication/authentication.module';
import { DevTestingModule } from '../dev-testing/dev-testing.module';
import { DockingModule } from '../docking/docking.module';
import { NavigationModule } from '../navigation/navigation.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { ServerCommunicationModule } from '../server-communication/server-communication.module';
import { SharedModule } from '../shared/shared.module';
import { AnonymousLayoutComponent } from './anonymous-layout/anonymous-layout.component';
import { AuthenticatedLayoutComponent } from './authenticated-layout/authenticated-layout.component';
import { AuthorizationModule } from '../authorization/authorization.module';

@NgModule({
    declarations: [AnonymousLayoutComponent, AuthenticatedLayoutComponent],
    imports: [
        CommonModule,
        AppRoutingModule,
        SharedModule,
        AuthenticationModule,
        AuthorizationModule,
        NavigationModule,
        ServerCommunicationModule,
        DockingModule,
        NotificationsModule,
        DevTestingModule
    ],
    exports: [AnonymousLayoutComponent, AuthenticatedLayoutComponent]
})
export class LayoutsModule {}
